import { InputLabel, MenuItem, Select } from "@material-ui/core";
import React from "react";
import { LOG_TYPE_CODES } from "../../data/LogTypeCodes";

type Props = {
	LogTypeCode: number | string | null;
	setLogTypeCodeFilter: (logTypeCode: number | string | null) => void;
};

export const CodeFilter = ({ LogTypeCode, setLogTypeCodeFilter }: Props) => {
	return (
		<div
			style={{ marginTop: 6, borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
		>
			<InputLabel
				id="demo-simple-select-label"
				style={{ fontSize: 10, marginBottom: 0 }}
			>
				Type
			</InputLabel>
			<Select
				labelId="demo-simple-select-label"
				id="demo-simple-select"
				value={LogTypeCode}
				onChange={(newLogTypeCode) =>
					setLogTypeCodeFilter(newLogTypeCode.target.value as any)
				}
				style={{ minWidth: "100%" }}
			>
				{Object.values(LOG_TYPE_CODES).map((log) => {
					return (
						<MenuItem key={`logId-${log.id}`} value={log.id}>
							{log.description}
						</MenuItem>
					);
				})}
			</Select>
		</div>
	);
};
